<script lang="ts" setup>
import { ref } from 'vue';

import { CommandModal } from '@nora-monorepo/ui-shared';

import { ConversationCommandPlugin } from '#nora-chat-ui/components/modals/command-modal-plugins/conversation-command-plugin';
import FilesModal from '#nora-chat-ui/components/modals/files-modal/FilesModal.vue';
import { ConversationModalActionState } from '#nora-chat-ui/components/modals/new-conversation/conversation-modal-types';
import ConversationModal from '#nora-chat-ui/components/modals/new-conversation/ConversationModal.vue';

const showCreateConversationModal = ref(false);

function openCreateConversationModal() {
  showCreateConversationModal.value = true;
}

function closeCreateConversationModal() {
  showCreateConversationModal.value = false;
}
</script>

<template>
  <ConversationModal
    :is-open="showCreateConversationModal"
    :mode="ConversationModalActionState.Create"
    @close="closeCreateConversationModal"
  />
  <FilesModal />
  <CommandModal
    modal-id="chatCommandModal"
    :plugins="[ConversationCommandPlugin(openCreateConversationModal)]"
  />
</template>
